import { Button, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';
import AddNewFormModal from './AddNewFormModal';

interface addDocument {
  count: number;
  setCount: any;
}

function AddNewFormButton({ count, setCount }: addDocument) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        h="35px"
        w="fit-content"
        fontSize="15px"
        bg="#002677"
        textColor="white"
        mr="0.5rem"
        float="right"
        ml="auto"
        onClick={onOpen}
      >
        Add Form
      </Button>

      <AddNewFormModal
        isOpen={isOpen}
        onClose={onClose}
        count={count}
        setCount={setCount}
      />
    </>
  );
}

export default AddNewFormButton;
